export class UndoRedoAction {
    constructor() {
        Object.defineProperty(this, "internalName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get name() {
        return this.internalName;
    }
    set name(name) {
        this.internalName = name;
    }
    run() {
        return;
    }
    undo() {
        return;
    }
    redo() {
        this.run();
    }
    destroy() {
        return;
    }
}
export class LazyUndoRedoAction extends UndoRedoAction {
    queued() {
        return;
    }
}
